import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import ElementUI from 'element-ui';
import { post, get, postJson } from './utils/request';
import { dialogFormReset, goBack } from '@/utils/index';
import modal from '@/utils/modal';
import '@/filters';

import '@/icons'; // icon
import 'normalize.css/normalize.css'; // a modern alternative to CSS resets
import '@/styles/index.scss'; // global css
import '@/styles/element-variables.scss';

// 自定义指令
import elDragDialog from '@/directive/el-drag-dialog';
import auth from '@/directive/permission';

// 全局组件
import DragDialog from '@/components/DragDialog';

Vue.prototype.$post = post;
Vue.prototype.$get = get;
Vue.prototype.$postJson = postJson;
Vue.prototype.$imgUrl = process.env.VUE_APP_IMG_URL;
// 模态框封装对象
Vue.prototype.$modal = modal;
Vue.prototype.$dialogFormReset = dialogFormReset; // dialog弹窗表达重置data参数和form校验 封装
Vue.prototype.$goBack = goBack; // 页面返回 封装

import vueSeamlessScroll from 'vue-seamless-scroll'; //滚动组件
Vue.use(vueSeamlessScroll);
Vue.use(elDragDialog).use(auth);

// el-table全局设置
ElementUI.TableColumn.props.showOverflowTooltip = { type: Boolean, default: true };
Vue.use(ElementUI, { size: 'small' });

Vue.config.productionTip = false;
Vue.component('DragDialog', DragDialog);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
